import { CustomError } from 'ts-custom-error';

/**
 * Internal error class to distinguish fetch errors from timeout errors
 */
export class FetchTimeoutError extends CustomError {
  constructor(msg: string) {
    super(msg);

    // Set name explicitly as minification can mangle class names
    Object.defineProperty(this, 'name', { value: 'FetchTimeoutError' });
  }
}
